import { jsx as _jsx } from "react/jsx-runtime";
import { createContext } from 'react';
export const ThemeContext = createContext(null);
export function UIProvider({ theme, children }) {
    return _jsx(ThemeContext.Provider, { value: theme, children: children });
}
//# sourceMappingURL=UIProvider.js.map